var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
    },
    [
      _vm.recordList.length > 0
        ? _c(
            "div",
            [
              _c(
                "el-timeline",
                _vm._l(_vm.recordList, function (item, index) {
                  return _c(
                    "el-timeline-item",
                    {
                      key: index,
                      attrs: {
                        timestamp:
                          item.installStep +
                          (item.createBy ? "     " + item.createBy : "") +
                          "                    " +
                          item.createTime,
                        color: _vm.getTimelineColor(item.installStep),
                        placement: "top",
                      },
                    },
                    [
                      _c(
                        "el-card",
                        { attrs: { shadow: "hover", size: "small" } },
                        [
                          item.remark
                            ? _c("div", { staticClass: "log-info-item" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "log-info-value",
                                    staticStyle: {
                                      "font-size": "16px",
                                      "font-weight": "bold",
                                    },
                                  },
                                  [_vm._v(_vm._s(item.remark))]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "log-info-grid" }, [
                            item.contractNumber
                              ? _c("div", { staticClass: "log-info-item" }, [
                                  _c(
                                    "span",
                                    { staticClass: "log-info-label" },
                                    [_vm._v("合同号：")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "log-info-value" },
                                    [_vm._v(_vm._s(item.contractNumber))]
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            item.quantity !== null &&
                            item.quantity !== undefined
                              ? _c("div", { staticClass: "log-info-item" }, [
                                  _c(
                                    "span",
                                    { staticClass: "log-info-label" },
                                    [_vm._v("数量：")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "log-info-value" },
                                    [_vm._v(_vm._s(item.quantity))]
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _vm.isSignIn(item.installStep)
                            ? _c("div", { staticClass: "log-section" }, [
                                _c(
                                  "div",
                                  { staticClass: "log-section-title" },
                                  [_vm._v("签到信息")]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "log-info-grid" }, [
                                  item.coordinateAddress
                                    ? _c(
                                        "div",
                                        { staticClass: "log-info-item" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "log-info-label" },
                                            [_vm._v("坐标地址：")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "log-info-value" },
                                            [
                                              _vm._v(
                                                _vm._s(item.coordinateAddress)
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.coordinateX !== null &&
                                  item.coordinateX !== undefined
                                    ? _c(
                                        "div",
                                        { staticClass: "log-info-item" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "log-info-label" },
                                            [_vm._v("坐标：")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "log-info-value" },
                                            [
                                              _vm._v(
                                                _vm._s(item.coordinateX) +
                                                  ", " +
                                                  _vm._s(item.coordinateY)
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isBeforeInstall(item.installStep)
                            ? _c("div", { staticClass: "log-section" }, [
                                _c("div", { staticClass: "log-media-grid" }, [
                                  item.photoClothes
                                    ? _c(
                                        "div",
                                        { staticClass: "log-media-item" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "log-info-label" },
                                            [_vm._v("着装图：")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "log-photo-list" },
                                            _vm._l(
                                              _vm.getPhotoList(
                                                item.photoClothes
                                              ),
                                              function (url, idx) {
                                                return _c("el-image", {
                                                  key: idx,
                                                  staticStyle: {
                                                    width: "80px",
                                                    height: "80px",
                                                  },
                                                  attrs: {
                                                    src: url,
                                                    "preview-src-list":
                                                      _vm.getPhotoList(
                                                        item.photoClothes
                                                      ),
                                                    "initial-index": idx,
                                                    fit: "cover",
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.videoClothes
                                    ? _c(
                                        "div",
                                        { staticClass: "log-media-item" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "log-info-label" },
                                            [_vm._v("着装视频：")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "video",
                                            {
                                              staticStyle: {
                                                width: "80px",
                                                background: "#000",
                                              },
                                              attrs: {
                                                src: item.videoClothes,
                                                controls: "",
                                              },
                                            },
                                            [_vm._v("您的浏览器不支持视频播放")]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.photoScene
                                    ? _c(
                                        "div",
                                        { staticClass: "log-media-item" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "log-info-label" },
                                            [_vm._v("现场检查图：")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "log-photo-list" },
                                            _vm._l(
                                              _vm.getPhotoList(item.photoScene),
                                              function (url, idx) {
                                                return _c("el-image", {
                                                  key: idx,
                                                  staticStyle: {
                                                    width: "80px",
                                                    height: "80px",
                                                  },
                                                  attrs: {
                                                    src: url,
                                                    "preview-src-list":
                                                      _vm.getPhotoList(
                                                        item.photoScene
                                                      ),
                                                    "initial-index": idx,
                                                    fit: "cover",
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.videoScene
                                    ? _c(
                                        "div",
                                        { staticClass: "log-media-item" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "log-info-label" },
                                            [_vm._v("现场检查视频：")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "video",
                                            {
                                              staticStyle: {
                                                width: "80px",
                                                background: "#000",
                                              },
                                              attrs: {
                                                src: item.videoScene,
                                                controls: "",
                                              },
                                            },
                                            [_vm._v("您的浏览器不支持视频播放")]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.photoSceneProtect
                                    ? _c(
                                        "div",
                                        { staticClass: "log-media-item" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "log-info-label" },
                                            [_vm._v("现场保护图：")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "log-photo-list" },
                                            _vm._l(
                                              _vm.getPhotoList(
                                                item.photoSceneProtect
                                              ),
                                              function (url, idx) {
                                                return _c("el-image", {
                                                  key: idx,
                                                  staticStyle: {
                                                    width: "80px",
                                                    height: "80px",
                                                  },
                                                  attrs: {
                                                    src: url,
                                                    "preview-src-list":
                                                      _vm.getPhotoList(
                                                        item.photoSceneProtect
                                                      ),
                                                    "initial-index": idx,
                                                    fit: "cover",
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.videoSceneProtect
                                    ? _c(
                                        "div",
                                        { staticClass: "log-media-item" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "log-info-label" },
                                            [_vm._v("现场保护视频：")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "video",
                                            {
                                              staticStyle: {
                                                width: "80px",
                                                background: "#000",
                                              },
                                              attrs: {
                                                src: item.videoSceneProtect,
                                                controls: "",
                                              },
                                            },
                                            [_vm._v("您的浏览器不支持视频播放")]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.photoMeasure
                                    ? _c(
                                        "div",
                                        { staticClass: "log-media-item" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "log-info-label" },
                                            [_vm._v("现场复尺图：")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "log-photo-list" },
                                            _vm._l(
                                              _vm.getPhotoList(
                                                item.photoMeasure
                                              ),
                                              function (url, idx) {
                                                return _c("el-image", {
                                                  key: idx,
                                                  staticStyle: {
                                                    width: "80px",
                                                    height: "80px",
                                                  },
                                                  attrs: {
                                                    src: url,
                                                    "preview-src-list":
                                                      _vm.getPhotoList(
                                                        item.photoMeasure
                                                      ),
                                                    "initial-index": idx,
                                                    fit: "cover",
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.videoMeasure
                                    ? _c(
                                        "div",
                                        { staticClass: "log-media-item" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "log-info-label" },
                                            [_vm._v("现场复尺视频：")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "video",
                                            {
                                              staticStyle: {
                                                width: "80px",
                                                background: "#000",
                                              },
                                              attrs: {
                                                src: item.videoMeasure,
                                                controls: "",
                                              },
                                            },
                                            [_vm._v("您的浏览器不支持视频播放")]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "log-info-grid" }, [
                                  item.goodFull
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "log-info-item log-info-full",
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "log-info-label" },
                                            [_vm._v("货物完整性：")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "log-info-value" },
                                            [_vm._v(_vm._s(item.goodFull))]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.goodFullNum
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "log-info-item log-info-full",
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "log-info-label" },
                                            [_vm._v("账实相符：")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "log-info-value" },
                                            [_vm._v(_vm._s(item.goodFullNum))]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isInProgress(item.installStep)
                            ? _c("div", { staticClass: "log-section" }, [
                                _c("div", { staticClass: "log-media-grid" }, [
                                  item.photoProgress
                                    ? _c(
                                        "div",
                                        { staticClass: "log-media-item" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "log-info-label" },
                                            [_vm._v("进度图：")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "log-photo-list" },
                                            _vm._l(
                                              _vm.getPhotoList(
                                                item.photoProgress
                                              ),
                                              function (url, idx) {
                                                return _c("el-image", {
                                                  key: idx,
                                                  staticStyle: {
                                                    width: "80px",
                                                    height: "80px",
                                                  },
                                                  attrs: {
                                                    src: url,
                                                    "preview-src-list":
                                                      _vm.getPhotoList(
                                                        item.photoProgress
                                                      ),
                                                    "initial-index": idx,
                                                    fit: "cover",
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.videoProgress
                                    ? _c(
                                        "div",
                                        { staticClass: "log-media-item" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "log-info-label" },
                                            [_vm._v("进度视频：")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "video",
                                            {
                                              staticStyle: {
                                                width: "80px",
                                                background: "#000",
                                              },
                                              attrs: {
                                                src: item.videoProgress,
                                                controls: "",
                                              },
                                            },
                                            [_vm._v("您的浏览器不支持视频播放")]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isComplete(item.installStep)
                            ? _c("div", { staticClass: "log-section" }, [
                                _c("div", { staticClass: "log-media-grid" }, [
                                  item.photo
                                    ? _c(
                                        "div",
                                        { staticClass: "log-media-item" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "log-info-label" },
                                            [_vm._v("分装现场图：")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "log-photo-list" },
                                            _vm._l(
                                              _vm.getPhotoList(item.photo),
                                              function (url, idx) {
                                                return _c("el-image", {
                                                  key: idx,
                                                  staticStyle: {
                                                    width: "80px",
                                                    height: "80px",
                                                  },
                                                  attrs: {
                                                    src: url,
                                                    "preview-src-list":
                                                      _vm.getPhotoList(
                                                        item.photo
                                                      ),
                                                    "initial-index": idx,
                                                    fit: "cover",
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.video
                                    ? _c(
                                        "div",
                                        { staticClass: "log-media-item" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "log-info-label" },
                                            [_vm._v("分装现场视频：")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "video",
                                            {
                                              staticStyle: {
                                                width: "80px",
                                                background: "#000",
                                              },
                                              attrs: {
                                                src: item.video,
                                                controls: "",
                                              },
                                            },
                                            [_vm._v("您的浏览器不支持视频播放")]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.photoFinish
                                    ? _c(
                                        "div",
                                        { staticClass: "log-media-item" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "log-info-label" },
                                            [_vm._v("成品完工图：")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "log-photo-list" },
                                            _vm._l(
                                              _vm.getPhotoList(
                                                item.photoFinish
                                              ),
                                              function (url, idx) {
                                                return _c("el-image", {
                                                  key: idx,
                                                  staticStyle: {
                                                    width: "80px",
                                                    height: "80px",
                                                  },
                                                  attrs: {
                                                    src: url,
                                                    "preview-src-list":
                                                      _vm.getPhotoList(
                                                        item.photoFinish
                                                      ),
                                                    "initial-index": idx,
                                                    fit: "cover",
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.videoFinish
                                    ? _c(
                                        "div",
                                        { staticClass: "log-media-item" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "log-info-label" },
                                            [_vm._v("成品视频：")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "video",
                                            {
                                              staticStyle: {
                                                width: "80px",
                                                background: "#000",
                                              },
                                              attrs: {
                                                src: item.videoFinish,
                                                controls: "",
                                              },
                                            },
                                            [_vm._v("您的浏览器不支持视频播放")]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.sceneFinishProtect
                                    ? _c(
                                        "div",
                                        { staticClass: "log-media-item" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "log-info-label" },
                                            [_vm._v("成品保护图：")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "log-photo-list" },
                                            _vm._l(
                                              _vm.getPhotoList(
                                                item.sceneFinishProtect
                                              ),
                                              function (url, idx) {
                                                return _c("el-image", {
                                                  key: idx,
                                                  staticStyle: {
                                                    width: "80px",
                                                    height: "80px",
                                                  },
                                                  attrs: {
                                                    src: url,
                                                    "preview-src-list":
                                                      _vm.getPhotoList(
                                                        item.sceneFinishProtect
                                                      ),
                                                    "initial-index": idx,
                                                    fit: "cover",
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.videoFinishProtect
                                    ? _c(
                                        "div",
                                        { staticClass: "log-media-item" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "log-info-label" },
                                            [_vm._v("成品保护视频：")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "video",
                                            {
                                              staticStyle: {
                                                width: "80px",
                                                background: "#000",
                                              },
                                              attrs: {
                                                src: item.videoFinishProtect,
                                                controls: "",
                                              },
                                            },
                                            [_vm._v("您的浏览器不支持视频播放")]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.photoFinishCheck
                                    ? _c(
                                        "div",
                                        { staticClass: "log-media-item" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "log-info-label" },
                                            [_vm._v("完工验收单照片：")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "log-photo-list" },
                                            _vm._l(
                                              _vm.getPhotoList(
                                                item.photoFinishCheck
                                              ),
                                              function (url, idx) {
                                                return _c("el-image", {
                                                  key: idx,
                                                  staticStyle: {
                                                    width: "80px",
                                                    height: "80px",
                                                  },
                                                  attrs: {
                                                    src: url,
                                                    "preview-src-list":
                                                      _vm.getPhotoList(
                                                        item.photoFinishCheck
                                                      ),
                                                    "initial-index": idx,
                                                    fit: "cover",
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.photoSceneLaji
                                    ? _c(
                                        "div",
                                        { staticClass: "log-media-item" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "log-info-label" },
                                            [_vm._v("现场垃圾图片：")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "log-photo-list" },
                                            _vm._l(
                                              _vm.getPhotoList(
                                                item.photoSceneLaji
                                              ),
                                              function (url, idx) {
                                                return _c("el-image", {
                                                  key: idx,
                                                  staticStyle: {
                                                    width: "80px",
                                                    height: "80px",
                                                  },
                                                  attrs: {
                                                    src: url,
                                                    "preview-src-list":
                                                      _vm.getPhotoList(
                                                        item.photoSceneLaji
                                                      ),
                                                    "initial-index": idx,
                                                    fit: "cover",
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.videoSceneLaji
                                    ? _c(
                                        "div",
                                        { staticClass: "log-media-item" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "log-info-label" },
                                            [_vm._v("现场垃圾视频：")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "video",
                                            {
                                              staticStyle: {
                                                width: "80px",
                                                background: "#000",
                                              },
                                              attrs: {
                                                src: item.videoSceneLaji,
                                                controls: "",
                                              },
                                            },
                                            [_vm._v("您的浏览器不支持视频播放")]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.photoLaji
                                    ? _c(
                                        "div",
                                        { staticClass: "log-media-item" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "log-info-label" },
                                            [_vm._v("垃圾堆放图：")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "log-photo-list" },
                                            _vm._l(
                                              _vm.getPhotoList(item.photoLaji),
                                              function (url, idx) {
                                                return _c("el-image", {
                                                  key: idx,
                                                  staticStyle: {
                                                    width: "80px",
                                                    height: "80px",
                                                  },
                                                  attrs: {
                                                    src: url,
                                                    "preview-src-list":
                                                      _vm.getPhotoList(
                                                        item.photoLaji
                                                      ),
                                                    "initial-index": idx,
                                                    fit: "cover",
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.videoLaji
                                    ? _c(
                                        "div",
                                        { staticClass: "log-media-item" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "log-info-label" },
                                            [_vm._v("垃圾堆放视频：")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "video",
                                            {
                                              staticStyle: {
                                                width: "80px",
                                                background: "#000",
                                              },
                                              attrs: {
                                                src: item.videoLaji,
                                                controls: "",
                                              },
                                            },
                                            [_vm._v("您的浏览器不支持视频播放")]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "log-info-grid" }, [
                                  item.hasLaji
                                    ? _c(
                                        "div",
                                        { staticClass: "log-info-item" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "log-info-label" },
                                            [_vm._v("是否有垃圾：")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "log-info-value" },
                                            [_vm._v(_vm._s(item.hasLaji))]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.installProgress
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "log-info-item log-info-full",
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "log-info-label" },
                                            [_vm._v("安装进度：")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "log-info-value" },
                                            [
                                              _vm._v(
                                                _vm._s(item.installProgress)
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]),
                              ])
                            : _vm._e(),
                        ]
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "pagination" },
                [
                  _vm.total > 0
                    ? _c("el-pagination", {
                        attrs: {
                          layout: "prev, pager, next",
                          total: _vm.total,
                          "page-size": _vm.pageSize,
                          "current-page": _vm.currentPage,
                          small: "",
                          background: "",
                        },
                        on: {
                          "update:currentPage": function ($event) {
                            _vm.currentPage = $event
                          },
                          "update:current-page": function ($event) {
                            _vm.currentPage = $event
                          },
                          "current-change": _vm.handlePageChange,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : !_vm.loading
        ? _c(
            "div",
            {
              staticStyle: {
                "text-align": "center",
                padding: "40px",
                color: "#909399",
              },
            },
            [_vm._v("\n    暂无操作记录\n  ")]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }